<span class="fw-normal mb-2 d-block">
  {{ 'product-variant-optie-selecteer-kleur-titel' | fromDictionary }}
  @if (hoverLabel || getLabel(activeProduct)) {
    -
    @if (!hoverLabel) {
      <span>{{ getLabel(activeProduct) }}</span>
    }
    @if (hoverLabel) {
      <span class="color-preview">{{ hoverLabel }}</span>
    }
  }
</span>

<ul class="swatch-list">
  @for (product of products; track product.id) {
    <li class="swatch-list__item">
      <a
        [routerLink]="['../', product.handle]"
        [routerLinkActive]="'is--active'"
        [class.is--white]="
          getMetafield(product, 'kleur_filter')?.value === 'Wit' ||
          (!getMetafield(product, 'kleurcode')?.value && !getMetaImage(product, 'kleur_afbeelding'))
        "
        [style.--swatch-color]="getMetafield(product, 'kleurcode')?.value || 'white'"
        [style.--swatch-image]="getMetaImage(product, 'kleur_afbeelding')"
        (mouseenter)="hoverLabel = getLabel(product)"
        (mouseleave)="hoverLabel = undefined"
        class="swatch"
      >
        <span class="sr-only">Choose color: {{ getMetafield(product, 'kleur_filter')?.value }}</span>
        @if (!product.availableForSale) {
          <div class="swatch__cross"></div>
        }
      </a>
    </li>
  }
</ul>
